angular.module("digitalLeasing.module").component("riepilogoPreventivo", {
  templateUrl: "ng/components/digitalLeasing/acceptance/riepilogoPreventivo/riepilogoPreventivo.view.html",
  bindings: {
    idWfInstance: "<",
    id: "<",
    model: "=",
    isTariffaPlafond: "<",
    checkDownloadPreventivo: "&?",
    financialModel: "=",
    giveAcceptanceDownloadList: "&?",
    checkPreventivePrint: "&?",
    contactEmail: "=",
    contactPec: "=",
    snapshot: '<',
    portalRunned: '<',
    exportRiferimenti: '&'
  },
  controllerAs: "riepilogoPreventivoCtrl",
  controller: function (
    $configService,
    $modalService,
    $workflowService,
    $simulationService,
    $rootScope,
    $portalService,
    $location,
    $scope,
    $download
  ) {

    var self = this;

    self.downloadList = [{}];

    self.$onInit = function () {
      $scope.listform = {};
      self.portalService = $portalService;

      self.model.daNotificareArc = true;

      self.numberOfCharMax = 35;

      self.financialModel = self.financialModel;

      self.isTariffaPlafond = self.isTariffaPlafond;

      self.showTooltip = false;

      self.supportModel = {
        wannaNotifyByArc: false,
        registeredOnArc: true,
        contactEmail: null,
        contactPec: null,
        isBackGroundPrint: true,
        notifiedArc: false,
        showContacts: false,
        bankEmail: null,
        bankPhone: null,
        persRif: null,
        showBankContacts: null,
        note: []
      }

      if (self.model.status == 'P150' || self.model.status == null) {
        self.isPreventivoPrinted = false;
      } else {
        self.isPreventivoPrinted = true;
        self.checkPreventivePrint({
          isPreventivePrinted: self.isPreventivoPrinted
        });
      }

      self.requestToGetPrintOptions();

      if (self.model.prodotto.bene.descrizione != null && self.model.prodotto.bene.descrizione.length > self.numberOfCharMax) {

        self.showTooltip = true;

      }

	  //RN:12255567
	  //Devo disabilitare la scelta della notifica ARC e impostare sempre la scelta NO se dovesse essere slimLeasing
	  if (self.model.araOnly || self.financialModel.leasingData.preventivo.slimLeasing) {
	    self.model.daNotificareArc = false;
	    self.disableArcNotificationRadio = true;
	  }

      if (self.financialModel.leasingData.id) {
        self.requestChecklistDoc();
      }
      self.restIsPending = true;
      self.bankFound = false;
      self.clientFound = false;
    }

    self.requestChecklistDoc = function () {
      if (!self.model.numero && !self.model.anno) {
        return;
      }
      $simulationService
        .populateCheckListTrasparenza(self.model, self.financialModel.financialVendor.reteVendita, self.financialModel.leasingData.id)
        .then(function (response) {

          self.downloadList = response.metadataUniUpload.downloadFile;
          self.rpDocDownInfo = response.metadataUniUpload.rpDocDownInfo;
          console.log(response);
          if (self.rpDocDownInfo.prevDownloaded) {
            self.downloadPreventivo();
          }

          self.giveAcceptanceDownloadList({
            downloadList: self.downloadList
          });

        })
        .catch(function (error) {
          console.log("ERROR: ", error);
        })
    }

    self.confirmPrint = function (status, isBackGroundPrint) {

      self.financialModel.leasingData.preventivo.contatti.riferimenti = self.riferimenti;
      $rootScope.$broadcast("pageLoader", {
        action: "OPEN"
      });

      var type = "WF_DIGITAL";
      var onlyLocal = false;

      if (status == 'P150' && !isBackGroundPrint && !self.snapshot) {
        $workflowService
          .checkConcurrence(self.idWfInstance)
          .then(function (response) {
            if (response.success) {
              $simulationService
                .printPreventive(self.financialModel, type, onlyLocal)
                .then(function (response) {
                  if (response.success) {

                    self.isPreventivoPrinted = true;
                    self.financialModel.viewIndex = response.viewIndex;
                    self.model.numero = response.numero;
                    self.model.anno = response.anno;
                    self.model.status = response.status;
                    self.model.nuovoPrestoleasing = response.nuovoPrestoleasing;
                    self.model.cdRaggrConvenzione = response.cdRaggrConvenzione;
                    self.model.convenzionePrm.cdConvenzione = response.convenzionePrm;
                    self.model.convenzionePrm.tipoConvenzione = "PRM";
                    self.model.nuovoPrestoleasingDerogabile = response.nuovoPrestoleasingDerogabile;

                    self.checkPreventivePrint({
                      isPreventivePrinted: self.isPreventivoPrinted
                    });

                    $simulationService
                      .populateCheckListTrasparenza(self.model, self.financialModel.financialVendor.reteVendita, self.financialModel.leasingData.id)
                      .then(function (response) {

                        if (response.success) {
                          self.downloadList = response.metadataUniUpload.downloadFile;
                          self.rpDocDownInfo = response.metadataUniUpload.rpDocDownInfo;
                          console.log(response);
                          if (self.rpDocDownInfo.prevDownloaded) {
                            self.downloadPreventivo();
                          }
                        }

                        self.giveAcceptanceDownloadList({
                          downloadList: self.downloadList
                        });

                      })
                      .catch(function (error) {
                        console.log("ERROR: ", error);
                      })

                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE"
                    });
                    $modalService.closeModal("pprint-modal");
                    self.toggleFooterZindex('back');

                  } else {
                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE"
                    });
                  }
                }).catch(function (err) {
                  console.log("ERRORE: ", err)
                })
            }
          })
          .catch(function (err) {
            console.log("ERRORE: ", err);
            $rootScope.$broadcast("pageLoader", {
              action: "CLOSE"
            });
          })

      } else if (status == 'P150' && isBackGroundPrint && !self.snapshot) {

        //qui in realtà viene invocato un nuovo rest 
        $workflowService
          .checkConcurrence(self.idWfInstance)
          .then(function (response) {
            if (response.success) {
              $simulationService
                .printPreventiveAsync(self.financialModel, type, onlyLocal)
                .then(function (response) {
                  if (response.success) {

                    self.isPreventivoPrinted = true;
                    self.financialModel.viewIndex = response.viewIndex;
                    self.model.numero = response.numero;
                    self.model.anno = response.anno;
                    self.model.status = response.status;
                    self.model.nuovoPrestoleasing = response.nuovoPrestoleasing;
                    self.model.cdRaggrConvenzione = response.cdRaggrConvenzione;
                    self.model.convenzionePrm.cdConvenzione = response.convenzionePrm;
                    self.model.convenzionePrm.tipoConvenzione = "PRM";
                    self.model.nuovoPrestoleasingDerogabile = response.nuovoPrestoleasingDerogabile;

                    self.checkPreventivePrint({
                      isPreventivePrinted: self.isPreventivoPrinted
                    });

                    $simulationService
                      .populateCheckListTrasparenza(self.model, self.financialModel.financialVendor.reteVendita, self.financialModel.leasingData.id)
                      .then(function (response) {

                        if (response.success) {
                          self.downloadList = response.metadataUniUpload.downloadFile;
                        }

                        self.giveAcceptanceDownloadList({
                          downloadList: self.downloadList
                        });

                      })
                      .catch(function (error) {
                        console.log("ERROR: ", error);
                      })

                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE"
                    });
                    $modalService.closeModal("pprint-modal");
                    self.toggleFooterZindex('back');
                    $location.path("/");

                  } else {
                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE"
                    });
                  }
                }).catch(function (err) {
                  console.log("ERRORE: ", err)
                })
            }
          })
          .catch(function (err) {
            console.log("ERRORE: ", err);
            $rootScope.$broadcast("pageLoader", {
              action: "CLOSE"
            });
          })

      } else if (status != 'P150' && !isBackGroundPrint && !self.snapshot) {
        $workflowService
          .checkConcurrence(self.idWfInstance)
          .then(function (response) {
            if (response.success) {
              $simulationService
                .printPreventive(self.financialModel, type, onlyLocal)
                .then(function (response) {
                  if (response.success) {
                    self.rpDocDownInfo.prevDownloaded = false;

                    self.checkDownloadPreventivo({
                      isPreventivo: false
                    });
                    self.isPreventivoPrinted = true;
                    self.financialModel.viewIndex = response.viewIndex;
                    self.model.numero = response.numero;
                    self.model.anno = response.anno;
                    self.model.status = response.status;
                    self.model.nuovoPrestoleasing = response.nuovoPrestoleasing;
                    self.model.cdRaggrConvenzione = response.cdRaggrConvenzione;
                    self.model.convenzionePrm.cdConvenzione = response.convenzionePrm;
                    self.model.convenzionePrm.tipoConvenzione = "PRM";
                    self.model.nuovoPrestoleasingDerogabile = response.nuovoPrestoleasingDerogabile;

                    self.checkPreventivePrint({
                      isPreventivePrinted: self.isPreventivoPrinted
                    });

                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE"
                    });
                    $modalService.closeModal("pprint-modal");
                    self.toggleFooterZindex('back');


                  } else {
                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE"
                    });
                  }
                }).catch(function (err) {
                  console.log("ERRORE: ", err)
                })
            }
          })
          .catch(function (err) {
            console.log("ERRORE: ", err);
            $rootScope.$broadcast("pageLoader", {
              action: "CLOSE"
            });
          })

      } else if (!self.snapshot) {
        $workflowService
          .checkConcurrence(self.idWfInstance)
          .then(function (response) {
            if (response.success) {
              $simulationService
                .printPreventiveAsync(self.financialModel, type, onlyLocal)
                .then(function (response) {
                  if (response.success) {

                    self.isPreventivoPrinted = true;
                    self.financialModel.viewIndex = response.viewIndex;
                    self.model.numero = response.numero;
                    self.model.anno = response.anno;
                    self.model.status = response.status;
                    self.model.nuovoPrestoleasing = response.nuovoPrestoleasing;
                    self.model.cdRaggrConvenzione = response.cdRaggrConvenzione;
                    self.model.convenzionePrm.cdConvenzione = response.convenzionePrm;
                    self.model.convenzionePrm.tipoConvenzione = "PRM";
                    self.model.nuovoPrestoleasingDerogabile = response.nuovoPrestoleasingDerogabile;

                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE"
                    });
                    $modalService.closeModal("pprint-modal");
                    self.toggleFooterZindex('back');
                    $location.path("/");
                  } else {
                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE"
                    });
                  }
                }).catch(function (err) {
                  console.log("ERRORE: ", err)
                })
            }
          })
          .catch(function (err) {
            console.log("ERRORE: ", err);
            $rootScope.$broadcast("pageLoader", {
              action: "CLOSE"
            });
          })
      }
    }

    self.generateLinkUrl = function (par) {
      var url = ""
      if (par === 'preventive') {
        url =
          "/uni/getFilePreventivo/service-infos/" +
          encodeURIComponent(parseInt(self.model.anno)) + "/" + encodeURIComponent(parseInt(self.model.numero)) + "/" + encodeURIComponent(parseInt(self.id))

      } else {
        url =
          "/uni/downloadGenericDigital/service-infos/PREC/003" +
          "/" +
          encodeURIComponent(null) +
          "/" +
          encodeURIComponent(parseInt(self.idWfInstance)) +
          "/"
      }

      $download.getGenericDownload(url)
        .then(function (response) {
          console.log(response);
          if (par === 'preventive') {
            self.downloadPreventivo()
          }
        })
    }

    self.openModalCFP = function () {
      $modalService.openModal("pprint-modal");
      self.toggleFooterZindex('');
    }

    self.downloadPreventivo = function () {
      if (self.rpDocDownInfo) {
        self.rpDocDownInfo.prevDownloaded = true;
      }
      self.checkDownloadPreventivo({
        isPreventivo: true
      });
    }

    self.requestToGetPrintOptions = function () {
      if (self.snapshot) {
        self.restIsPending = false;
        return;
      }
      self.restIsPending = true;
      $simulationService.
        getPrintOptions(self.model, self.financialModel.financialVendor.reteVendita, self.id)
        .then(function (response) {
          if (response.success) {
            if (response.warningPrevArc) {

              self.responseGetPrintOptions = response;
            }
            if (self.financialModel.frontEndOptions && self.financialModel.frontEndOptions.disableNavigationArc) {
              self.toggleFooterZindex();
              $modalService.openModal("warningPrevArc-modal");
            }
            self.model.printOptions.offertaFuoriSede = response.offertaFuoriSede;
            self.model.printOptions.offertaFuoriSedeBanca = response.offertaFuoriSedeBanca;
            self.model.printOptions.offertaInSede = response.offertaInSede;
            self.model.printOptions.speseContrAgev = response.speseContrAgev;
            self.model.printOptions.speseEsamePolizza = response.speseEsamePolizza;
            self.model.printOptions.speseGestioneBolloAuto = response.speseGestioneBolloAuto;
            self.model.printOptions.speseGestioneBolloMediatori = response.speseGestioneBolloMediatori;
            self.model.printOptions.speseIndicizzazione = response.speseIndicizzazione;
            self.model.printOptions.tassoLeasing = response.tassoLeasing;
            self.model.noArc = response.noArc;
            self.supportModel.contactEmail = response.emailContatto;
            self.supportModel.contactPec = response.emailPec;
            self.supportModel.registeredOnArc = response.registratoArc;
            self.supportModel.notifiedArc = response.notificatoArc;
            self.supportModel.showContacts = response.showContacts;
            self.supportModel.showBankContacts = response.showBankContacts;

            if (response.riferimenti) {
              self.riferimenti = response.riferimenti;
            } else {
              self.riferimenti = self.financialModel.leasingData.preventivo.contatti.riferimenti;
            }
            if (self.model.noArc) {
              self.model.daNotificareArc = false;
            }
            // METTO IN VARIABILI DI APPOGGIO PER VISUALIZZARLE
            if (self.supportModel.showContacts && self.riferimenti) {
              response.riferimenti && response.riferimenti.map(function (element) {
                if (element.id == 'BANCA') {
                  self.supportModel.bankEmail = element.email;
                  self.supportModel.bankPhone = element.telefono;
                  self.supportModel.persRif = element.description;
                }
              })
            }

            //PUSHO GLI ID IN CASO MANCASSERO
            self.riferimenti.forEach(function (element) {
              if (element.id === "BANCA") {
                self.bankFound = true;
              } else if (element.id === "CLIENTE") {
                self.clientFound = true;
              }
            });

            if (!self.bankFound) {
              self.riferimenti.push({
                id: "BANCA"
              });
            }
            if (!self.clientFound) {
              self.riferimenti.push({
                id: "CLIENTE"
              });
            }

            self.financialModel.leasingData.preventivo.contatti.riferimenti = response.riferimenti;
            //Show accordion contatti
            self.exportRiferimenti({
              printOptions: response
            })

            //save on riUserG
            self.contactPec = self.supportModel.contactPec;
            self.contactEmail = self.supportModel.contactEmail;

            self.restIsPending = false;
            self.errorOccured = false;
          } else {
            self.restIsPending = false;
            self.errorOccured = true;
          }
        })
        .catch(function (error) {
          console.log("Chiamata in errore: ", error);
          self.restIsPending = false;
          self.errorOccured = true;
        })
    }

    self.handleCheck = function (el) {
      el.value = !el.value;
    }

    self.$onChanges = function (changes) {
      console.log("model changed! :", changes);
    }

    self.checkInput = function () {
      if ($scope.listform.notifyPreventive.$valid) {
        return true
      } else {
        return false
      }
    }

    self.fieldChanges = function (name, value) {
      switch (name) {
        case 'email':
          self.financialModel.financialCustomer.metadata.riUserG.emailContatto = value;
          var index = self.riferimenti.findIndex(function (element) {
            return element.id == "CLIENTE"
          })
          self.riferimenti[index].email = value;
          break;
        case 'emailPec':
          self.financialModel.financialCustomer.metadata.riUserG.emailPec = value;
          break;
        case 'emailBanca':
          self.supportModel.bankEmail = value;
          var index = self.riferimenti.findIndex(function (element) {
            return element.id == "BANCA"
          })
          self.riferimenti[index].email = value;
          break;
        case 'telefonoBanca':
          self.supportModel.bankPhone = value;
          var index = self.riferimenti.findIndex(function (element) {
            return element.id == "BANCA"
          })
          self.riferimenti[index].telefono = value;
          break;
        case 'personaRif':
          self.supportModel.persRif = value;
          var index = self.riferimenti.findIndex(function (element) {
            return element.id == "BANCA"
          })
          self.riferimenti[index].description = value;
          break;
        case 'note':
          self.supportModel.note = value;
          self.financialModel.leasingData.preventivo.contatti.note = value;
          break;
      }
    }

    self.toggleFooterZindex = function (par) {
      if (par === 'back') {
        $(".financial-leasing__footer").css("z-index", "1");
      } else {
        $(".financial-leasing__footer").css("z-index", "-1");
      }
    }

    self.redirectDocumentazioneInformativa = function () {
      $location.path('/informativeDocs');
    }

    self.downloadCustomerInfo = function () {
      self.rpDocDownInfo.icDownloaded = true;
      var input = {
        downloadKey: self.rpDocDownInfo.linkIc
      }
      var url = "/uni/downloadGenericDigital/service-infos/"
      $download.getGenericDownload(url, input)
        .then(function (response) {
          console.log(response)
        })

    }

    self.closeModal = function (idModal) {
      $modalService.closeModal(idModal);
    }
  }
});